import { useState } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import {
  selectProfilePhoneFormatted,
  selectProfilePhoneVerified,
} from "../../app-main/selectors/profile.selectors";

import { EditFieldButton } from "./EditFieldButton";
import { Text } from "@ps-design-system/components/Text";
import { Button } from "@ps-design-system/components/Button";
import { EditVerifyPhoneModal } from "../../app-profile/EditVerifyPhoneModal";

export const ProfilePhone = () => {
  const phoneFormatted = useSelector(selectProfilePhoneFormatted);
  const isPhoneVerified = useSelector(selectProfilePhoneVerified);
  const [isEditOpen, setIsEditOpen] = useState(false);

  // Determine if the phone number is not verified & start on verify step if the phone number is already set
  const phoneIsNotVerified = phoneFormatted && !isPhoneVerified;

  const handleOpenModal = () => setIsEditOpen(true);
  const handleCloseModal = () => setIsEditOpen(false);

  return (
    <>
      <div className="tw-flex tw-items-center tw-gap-40">
        <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-4">
          <Text className="tw-text-gray-900" element="p" typeface="body-2-m">
            <FormattedMessage
              id="hosting.profile_page.phone_label"
              defaultMessage="Phone number"
            />
          </Text>
          <Text element="p" typeface="body-2" data-testid="host-profile-phone">
            {phoneFormatted}
          </Text>
        </div>
        <div className="tw-flex tw-shrink-0 tw-items-center tw-justify-end">
          <EditFieldButton
            onClick={handleOpenModal}
            showEditLabel={!!phoneFormatted}
          />
        </div>
      </div>
      {phoneIsNotVerified && (
        <Text className="tw-text-gray-600" element="p" typeface="caption-2">
          <FormattedMessage
            id="hosting.profile_page.phone_needs_verifying_caption"
            defaultMessage="Please {link} before making profile edits."
            values={{
              link: (
                <Button
                  onClick={handleOpenModal}
                  variant="underline"
                  className="tw-caption-2 tw-underline tw-p-0 tw-text-gray-600"
                  key="phone-caption-verify-link"
                >
                  <FormattedMessage
                    id="hosting.profile_page.phone_needs_verifying_caption_link"
                    defaultMessage="verify your number"
                  />
                </Button>
              ),
            }}
          />
        </Text>
      )}
      <Text>
        <FormattedMessage
          id="hosting.profile_page.mobile_number_helper_text"
          defaultMessage="We won’t share your number publicly. Guests will only see it after they book to coordinate with you."
        />
      </Text>
      {isEditOpen && (
        <EditVerifyPhoneModal
          open={isEditOpen}
          startingStep={phoneIsNotVerified ? "verify" : undefined}
          onOpenChange={handleCloseModal}
        />
      )}
    </>
  );
};
